import React from 'react';

import { InsideParallaxImage } from "components/Image/Index";

import { Parallax as ScrollParallax } from 'react-scroll-parallax';

import * as fromProjects from 'store/Projects';

import { a } from '@react-spring/web';
import { useIntersect } from 'hooks/useIntersect';
import { useAnimateInSpring } from 'hooks/useAnimateInSpring';
import { initialOffset } from 'components/Animations/SpringProperties/SpringProperties';

interface IProps {
  animationReady: boolean;
  bodyContent: object;
}

export const Parallax: React.FC<IProps> = ({ animationReady, ...props }) => {
  const bodyContent: fromProjects.IContentFullBleedImageSection = props.bodyContent as fromProjects.IContentFullBleedImageSection;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const animateInSpring = useAnimateInSpring(inView);

  const imageWrapperStyles = {
    opacity: animateInSpring.active,
    transform: animateInSpring.active.to(x => `translateY(calc(${initialOffset(x)}))`),
  };

  return (
    <div ref={inViewRef} className='fullBleedImageWrapper parallax'>
      <ScrollParallax y={['-200px', '200px']} tagOuter="figure">
        <a.div className='parallaxInner' style={imageWrapperStyles}>
          <InsideParallaxImage
            width='100%'
            height='100%'
            src={'/assets/images/work/' + bodyContent.image.url}
            //src={'https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Pieter_Bruegel_der_%C3%84ltere_-_Landschaft_mit_der_Flucht_nach_%C3%84gypten.jpg/1920px-Pieter_Bruegel_der_%C3%84ltere_-_Landschaft_mit_der_Flucht_nach_%C3%84gypten.jpg'}
            alt={bodyContent.image.alt}
            fit='cover'
            animateImageIn={true}
            animationType={'reveal'}
          />
        </a.div>
      </ScrollParallax>
    </div>
  );
};
